import { CallAnsweredElsewhereEvent, IncomingCallEvent } from "@/model/interface/IncomingCallEvent";
import { RecordingState } from "@/enum/RecordingState";
import { useSocketSubscription } from "@/hooks/useSocketSubscription";

export interface CallStatusUpdateEvent {
  type: string;
  callId: string;
  status: string;
  recordingState?: RecordingState;
}

export function useCallSocket(
  onIncomingCall: (event: IncomingCallEvent) => void,
  onCallStatusUpdate?: (event: CallStatusUpdateEvent) => void,
  onParticipantsChanged?: (callId: string) => void,
  onCallAnsweredElsewhere?: (event: CallAnsweredElsewhereEvent) => void,
) {
  useSocketSubscription("/user/queue/calls", (message) => {
    try {
      const event = JSON.parse(message.body) as { type: string; callId: string };
      if (event.type === "incoming_call" && !message.replayed) {
        onIncomingCall(event as IncomingCallEvent);
      } else if (event.type === "call_status_update") {
        onCallStatusUpdate?.(event as CallStatusUpdateEvent);
      } else if (event.type === "call_participants_changed") {
        onParticipantsChanged?.(event.callId);
      } else if (event.type === "call_answered_elsewhere" && !message.replayed) {
        onCallAnsweredElsewhere?.(event as CallAnsweredElsewhereEvent);
      }
    } catch (error) {
      console.error("Failed to parse call event", error);
    }
  });
}
